import React from "react";
import { Link } from "react-router-dom";
import { LuChevronRight } from "react-icons/lu";

import { BreadcrumbType } from "../../types/common";

interface BreadcrumbProps extends React.ComponentPropsWithoutRef<"nav"> {
  items: BreadcrumbType[];
}

export function Breadcrumb({ items, className, ...props }: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" className={`flex ${className || ""}`} {...props}>
      <ol className="flex items-center space-x-2 text-sm text-gray-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {item.href ? (
              <Link
                to={item.href}
                className="text-[#34699A] hover:text-[#113F67] transition-colors font-medium"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-700 font-semibold">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <LuChevronRight className="h-4 w-4 mx-2 text-gray-400" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
export default Breadcrumb;
